import React from 'react'
import {toast} from 'react-hot-toast';
 
 
class AddItem  extends React.Component {
   constructor(props){
    super(props);
       this.state = {
         productName : "",
         productPrice : 0
       };
   };

   handlePriceChange = (e) => {
    const value = e.currentTarget.value;
    const price = value.startsWith('0') ? value.slice(1) : value;
    this.setState({ productPrice: price });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    const { productName, productPrice } = this.state;

    if (productName.trim() !== '' && productPrice !== 0) {
      this.props.addItem(productName, Number(productPrice));
      toast.success("Added the Item!!");
    }
    else{
        toast.error("Please Enter the Product Name or Price!!");
    }
  };
  
    render() { 
        return (
        <form className='row' onSubmit={this.handleSubmit}>
            
        <div className="row mb-3 col-7">
            <label htmlFor="name" className="col-sm-2 col-form-label label">Name:</label>
            <div className="col-sm-10">
            <input type="string" className=" input form-control" id="custName" 
            name = "custName" />
        </div>
        </div>
        <div className="row mb-3 col-5">
            <label htmlFor="date" className="col-sm-2  col-form-label label"> Date: </label>
            <div className="col-sm-10">
            <input type="date" className="input form-control" id="Date"
             name = "date" />
            </div>
        </div>
        <div className="row mb-3 col-7">
            <label htmlFor="inputEmail3" className="col-sm-2 col-form-label label">Product:</label>
            <div className="col-sm-10">
            <input type="string" className=" input form-control" id="inputName" 
            name = "productName" onChange={(e)=>{
                this.setState({productName : e.currentTarget.value})
            }}
            value = {this.state.productName}
            />
            </div>
        </div>
        <div className="row mb-3 col-5">
            <label htmlFor="Price" className="col-sm-2  col-form-label label"> Price: </label>
            <div className="col-sm-10">
            <input type="number" className="input form-control" id="Price"
             name = "productPrice"  onChange={this.handlePriceChange}
             value={this.state.productPrice}/>
            </div>
        </div>
        
        <button type="submit" className="btn btn-primary col-3 m-auto button">AddItem</button>
        </form>
        );
    }
}
 
export default AddItem;